Vue.component('media-vault-picker', require('./components/MediaVault/Picker.vue').default);
Vue.component('post-likes-modal-component', require('./components/PostLikesModalComponent.vue').default);
Vue.component('post-comment-likes-modal-component', require('./components/PostCommentLikesModalComponent.vue').default);
Vue.component('post-unlocks-modal-component', require('./components/PostUnlocksModalComponent.vue').default);
Vue.component('subscription-options-modal-component', require('./components/SubscriptionOptionsModalComponent.vue').default);
Vue.component('tip-options-modal-component', require('./components/TipOptionsModalComponent.vue').default);
Vue.component('report-content-modal', require('./components/Report/ReportContentModal').default);

// DataTables Global Configuration
if(jQuery){
    $.extend(true, $.fn.dataTable.defaults, {
        responsive: true,
        dom: "<'table-responsive'tr>\n<'row align-items-center'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
        language: {
            paginate: {
                previous: '<i class="fa fa-lg fa-angle-left"></i>',
                next: '<i class="fa fa-lg fa-angle-right"></i>'
            }
        },
    });
}
